import {Flex, IconButton, Stack, Text} from "@chakra-ui/react";
import {useIntl} from "next-intl";
import PropTypes from "prop-types";
import React from "react";
import {BiTrashAlt as RemoveIcon} from "react-icons/bi";
import {FiUser as PerSeatIcon, FiUsers as PerFeatureIcon} from "react-icons/fi";
import {useDispatch} from "react-redux";

import {removeFromCart} from "../../../redux/draftShoppingCart.slice";

function CartItem(props) {
    const {
        cartItem
    } = props
    const intl = useIntl();
    const {cartItemName, categoryItemMaxOccupancy, cartItemPrice, cartItemQuantity, schemaId, start, end} = cartItem;
    const dispatch = useDispatch();

    const removeItemFromCart = () => {
        dispatch(removeFromCart({schemaId, start, end}))
    }

    return (
        <Flex direction='row'>
            <Flex direction='column' width='100%'>
                <Text fontSize='md' fontWeight="bold">{cartItemQuantity} x {cartItemName}</Text>
                <Stack direction='row' align='center'>
                    {cartItemQuantity * categoryItemMaxOccupancy > 1? <PerFeatureIcon size="20px"/> : <PerSeatIcon size="20px"/>}
                    <Text fontSize='md'>{cartItemQuantity * categoryItemMaxOccupancy} { cartItemQuantity * categoryItemMaxOccupancy > 1? 'Guests' : 'Guest' }</Text>
                    {/* <Spacer /> */}
                    <IconButton
                        onClick={removeItemFromCart}
                        size='xs'
                        variant='ghost'
                        aria-label='Remove from Cart'
                        opacity='0.5'
                        icon={<RemoveIcon size="16px"/>}
                    />
                </Stack>
                <Text fontSize='md' fontWeight="bold">{intl.formatNumber(cartItemQuantity * cartItemPrice, {
                    style: 'currency',
                    currency: 'USD'
                })}</Text>
            </Flex>
        </Flex>
    )
}

CartItem.propTypes = {
    cartItem: PropTypes.shape({
        cartItemName: PropTypes.string.isRequired,
        categoryItemMaxOccupancy: PropTypes.number.isRequired,
        cartItemPrice: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
        cartItemQuantity: PropTypes.number.isRequired,
        schemaId: PropTypes.number.isRequired,
    }).isRequired,
}

export default CartItem